<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <h3>{{'General.utils' | translate}}</h3>
  <div class="col-lg-12">
    <div class="wrapper wrapper-content animated fadeInUp">
      <ul class="notes">
        <li *ngFor="let conf of configurations">
          <div>
            <small *ngIf="conf.date">{{conf.date | date}}</small>
            <h4>
              <i [ngClass]="conf.icon" class="fa-2x"></i> {{conf.name}}
            </h4>
            <p>{{conf.description}}</p>
            <a>
              <i class="fas fa-times "></i>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div *ngFor="let conf of configurations" class="ibox float-e-margins">
    <div class="ibox-title">
      <h3>
        <i [ngClass]="conf.icon" class="fa-2x"></i> {{conf.name}} <small>{{conf.description}}</small>
      </h3>
    </div>
    <!------------------------------------------------------------------------->
    <div class="ibox-title">
      <h3>
        CONFIGURACIÓN A NIVEL DE APLICACIÓN:
      </h3>
    </div>
    <div class="ibox-content" *ngFor="let confItem of conf.items">
      <!--
      CONFIGURACION DE UN PARAMETRO DE TIPO PROPERTY
      -->
      <div class="row" *ngIf="confItem.type === 'PROPERTY'">
        <h4>
          <i class="far fa-file"></i>Propiedad: {{confItem.description}} - {{confItem.application.property.description}}
        </h4>
        <br />
        <span *ngIf="confItem.application.property.value">{{confItem.application.property.value}}</span>
        <span *ngIf="!confItem.application.property.value">{{'control.empty.property' | translate}}</span>
      </div>

      <!--
      CONFIGURACION DE UN PARAMETRO DE TIPO ATRIBUTO
      -->
      <div class="row" *ngIf="confItem.type === 'ATTRIBUTE'">
        <h4>
          <i class="fa fa-server"></i>Atributo: {{confItem.description}} -
          {{confItem.application.attribute.identifier}}
        </h4>
        <br />
        <span *ngIf="confItem.application.attribute.value">{{confItem.application.attribute.value}}</span>
        <span *ngIf="!confItem.application.attribute.value">{{'control.empty.property' | translate}}</span>
      </div>

      <!--
      CONFIGURACION DE UN PARAMETRO DE TIPO WebService
      -->
      <div class="row" *ngIf="confItem.type === 'WS_DEFINITION' && confItem.application.wsDefinition">
        <h4>
          <i class="fa fa-plug"></i>Definición: {{confItem.description}} -
          {{confItem.application.wsDefinition.declaration}}
        </h4>
        <div class="row">
          <span>
            <b>URL:</b> {{confItem.application.wsDefinition.endpoint}}</span>
        </div>
        <div class="row">
          <span>
            <b>{{'control.params' | translate}}:</b>
            <span *ngIf="!confItem.application.wsDefinition.listWSDefinitionParameterDTO">{{'control.noParams' |
              translate}}</span>
          </span>
        </div>
        <div class="row" *ngIf="confItem.application.wsDefinition.listWSDefinitionParameterDTO">
          <p-table [value]="confItem.application.wsDefinition.listWSDefinitionParameterDTO" sortField="name"
            sortOrder="1" [paginator]="false" class="footer-over-pagination">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="2">
                  No hay parámetros asociados a este WS
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColum="name" n>Nombre <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="value">Valor <p-sortIcon field="value"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-param>
              <tr>
                <td>{{param.name}}</td>
                <td>{{param.value}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="row">
          <span>
            <b>{{'control.handlers' | translate}}:</b>
            <span *ngIf="!confItem.application.wsDefinition.listWSDefinitionHandlerDTO">{{'control.noHandlers' |
              translate}}</span>
          </span>
        </div>
        <div class="row" *ngIf="confItem.application.wsDefinition.listWSDefinitionHandlerDTO">
          <p-table [value]="confItem.application.wsDefinition.listWSDefinitionHandlerDTO" sortOrder="1"
            [paginator]="false" class="footer-over-pagination" expandableRows="true">
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="5">
                  No hay handlers asociados a este WS
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th styleClass="col-icon" style="width: 5%"></th>
                <th style="width: 5%">Pivot </th>
                <th style="width: 5%">Position </th>
                <th>Handler </th>
                <th>HandlerType </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-handler let-expanded="expanded">p
              <tr>
                <td>
                  <button type="button" pButton pRipple [pRowToggler]="attribute"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td>{{handler.pivot}}</td>
                <td>{{handler.position}}</td>
                <td>{{handler.handler}}</td>
                <td>{{handler.handlerType}}</td>
              </tr>
            </ng-template>

            <ng-template let-handler pTemplate="rowexpansion">
              <div>
                <div class="row">
                  <div *ngFor="let attribute of handler.listWSAttributeHandlerDTO">
                    <formElement [model]="attribute" [fieldConfig]="getFieldConfigWSAttributeHandler(attribute)">
                    </formElement>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-table>
        </div>
        <div class="row">
          <button class="btn btn-primary" (click)="alert('Servicio probado')" type="button">{{'General.test' |
            translate}}</button>
        </div>
      </div>
    </div>
    <!------------------------------------------------------------------------->
    <div class="ibox-title">
      <h3>
        CONFIGURACIÓN ESPECÍFICA DE LA ENTIDAD:
      </h3>
    </div>
    <div class="ibox-content" *ngFor="let confItem of conf.items">
      <!--
      CONFIGURACION DE UN PARAMETRO DE TIPO CERTIFICATE (ENTIDAD)
      -->
      <div class="row" *ngIf="confItem.type === 'CERTIFICATE'">
        <h4>
          <i class="fa fa-server"></i>Certificado: {{confItem.description}} -
          {{confItem.refIdentifier}}
        </h4>
        <br />
        <span
          *ngIf="confItem.entity.certificate.certificateSubject">{{confItem.entity.certificate.certificateSubject}}</span>
        <span *ngIf="!confItem.entity.certificate.certificateSubject">{{'control.empty.property' | translate}}</span>

      </div>
      <!--
      CONFIGURACION DE UN PARAMETRO DE TIPO ATRIBUTO (ENTIDAD)
      -->
      <div class="row" *ngIf="confItem.type === 'ENTITY_ATTRIBUTE'">
        <h4>
          <i class="fa fa-server"></i>Atributo: {{confItem.description}} -
          {{confItem.entity.attribute.identifier}}
        </h4>
        <br />
        <span *ngIf="confItem.entity.attribute.value">{{confItem.entity.attribute.value}}</span>
        <span *ngIf="!confItem.entity.attribute.value">{{'control.empty.property' | translate}}</span>

      </div>



    </div>
  </div>
</div>